(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["editorial-video"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__editorialVideoInit) return;
    window.__editorialVideoInit = true;
    function init() {
      var videos = document.querySelectorAll('.js-editorial-video');
      videos.forEach(function (video) {
        video.muted = true;
        video.playsInline = true;
        var attempt = function () {
          var p = video.play();
          if (p && typeof p.catch === 'function') {
            p.catch(function () {
              document.addEventListener(
                'click',
                function () { video.play().catch(function () {}); },
                { once: true, capture: true }
              );
            });
          }
        };
        if (video.readyState >= 2) {
          attempt();
        } else {
          video.addEventListener('loadeddata', attempt, { once: true });
        }
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-guide"] && !Shopify.designMode) return;
  try {
    (function() {
    var dialog = document.getElementById('size-guide');
    if (!dialog) return;
    var triggers = document.querySelectorAll('[data-open-size-guide]');

    function open() {
      dialog.showModal();
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          dialog.classList.add('size-guide--open');
        });
      });
    }

    function close() {
      dialog.classList.remove('size-guide--open');
      setTimeout(function() {
        if (dialog.open) dialog.close();
      }, 200);
    }

    triggers.forEach(function(btn) {
      btn.addEventListener('click', open);
    });

    dialog.addEventListener('click', function(e) {
      if (e.target === dialog) close();
      if (e.target.closest('[data-close-size-guide]')) close();
    });

    dialog.addEventListener('close', function() {
      dialog.classList.remove('size-guide--open');
    });

    /* Highlight the row matching the currently-selected size radio */
    var table = dialog.querySelector('[data-size-table]');
    function syncActiveRow() {
      if (!table) return;
      var sizeInput = document.querySelector('.product__option input[type="radio"][name*="ize" i]:checked, .product__option input[type="radio"][name*="ărime" i]:checked, .product__option input[type="radio"][name*="arime" i]:checked');
      if (!sizeInput) return;
      var value = sizeInput.value.trim().toUpperCase();
      table.querySelectorAll('tbody tr').forEach(function(tr) {
        tr.classList.toggle('is-active', tr.getAttribute('data-size-row') === value);
      });
    }

    document.addEventListener('change', function(e) {
      if (e.target && e.target.matches('.product__option input[type="radio"]')) {
        syncActiveRow();
      }
    });

    syncActiveRow();
  })();
  } catch(e) { console.error(e); }
})();

})();
